import { render, staticRenderFns } from "./NoPermissionsTooltip.vue?vue&type=template&id=2a445862&"
import script from "./NoPermissionsTooltip.vue?vue&type=script&lang=ts&"
export * from "./NoPermissionsTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports